import { UserStatus } from '@app/origami-api/constants/user-statuses';
import {
  statusColorIdToCssClass,
  statusColorIdToTPTColor,
  StatusColors,
} from '@app/shared/ui/simple-components/status/status-models';
import { QueryServiceModel } from '@app/origami-api/services/query.service';
import { CountryWorkflowManagementServiceModel } from '@app/origami-api/services/country-workflow-management.service';
import { SiteVisitLogStatus } from '@app/origami-api/constants/site-visit-log-status';
import { StatusColor } from '@tpt/common/general/labels';
import CommonQueryStatus = QueryServiceModel.CommonQueryStatus;
import CountryMilestoneTemplateStatusDomain = CountryWorkflowManagementServiceModel.CountryMilestoneTemplateStatusType;
import CountryMilestoneTemplateStatusRoom = CountryWorkflowManagementServiceModel.CountryWorkflowMilestoneStatusType;
import CountryWorkflowStatusType = CountryWorkflowManagementServiceModel.CountryWorkflowStatusType;

/** Same values as FolderManagementServiceModel.WorkflowStageContributorStatus; kept local to avoid circular imports. */
enum WorkflowStageContributorStatus {
  Pending,
  InProgress,
  Completed,
  Rejected,
}

export const getColorForUser = (statusId: number): StatusColors => {
  switch (statusId) {
    case UserStatus.Pending:
      return StatusColors.StatusesOrange;
    case UserStatus.Invited:
      return StatusColors.StatusesPink;
    case UserStatus.Registered:
      return StatusColors.StatusesBlue;
    case UserStatus.Visited:
      return StatusColors.StatusesGrey;
    case UserStatus.NoAccess:
      return StatusColors.StatusesRedTransparent;
    case UserStatus.Active:
      return StatusColors.StatusesGreen;
    case UserStatus.ActiveWithAccess:
      return StatusColors.StatusesPastelGreen;
    case UserStatus.Deleted:
      return StatusColors.StatusesRed;
  }
};

export const getColorForWorkflowStageContributorStatus = (statusId: number): StatusColors => {
  switch (statusId) {
    case WorkflowStageContributorStatus.Pending:
      return StatusColors.StatusesOrange;
    case WorkflowStageContributorStatus.InProgress:
      return StatusColors.StatusesDandellion;
    case WorkflowStageContributorStatus.Completed:
      return StatusColors.StatusesGreen;
    case WorkflowStageContributorStatus.Rejected:
      return StatusColors.StatusesRed;
  }
};

export const getColorForQuery = (statusId: number): StatusColors => {
  switch (statusId) {
    case CommonQueryStatus.Pending:
      return StatusColors.StatusesDandellion;
    case CommonQueryStatus.InProgress:
      return StatusColors.StatusesOrange;
    case CommonQueryStatus.Resolved:
      return StatusColors.StatusesGreen;
  }
};

export const getColorForSiteVisit = (statusId: number): StatusColors => {
  switch (statusId) {
    case SiteVisitLogStatus.Scheduled:
      return StatusColors.StatusesOrange;
    case SiteVisitLogStatus.InProgress:
      return StatusColors.StatusesDandellion;
    case SiteVisitLogStatus.Completed:
      return StatusColors.StatusesGreen;
  }
};

export const getColorForCountryMilestoneTemplateStatusDomain = (statusId: number): StatusColors => {
  switch (statusId) {
    case CountryMilestoneTemplateStatusDomain.Active:
      return StatusColors.StatusesGreen;
    case CountryMilestoneTemplateStatusDomain.Inactive:
      return StatusColors.StatusesRed;
  }
};

export const getColorForCountryMilestoneTemplateStatusRoom = (statusId: number): StatusColors => {
  switch (statusId) {
    case CountryMilestoneTemplateStatusRoom.Planned:
      return StatusColors.StatusesBlue;
    case CountryMilestoneTemplateStatusRoom.Completed:
      return StatusColors.StatusesGreen;
    case CountryMilestoneTemplateStatusRoom.NotApplicable:
      return StatusColors.StatusesRed;
  }
};

export const getColorForCountryWorkflowTemplateStatusDomain = (statusId: number): StatusColors => {
  switch (statusId) {
    case CountryWorkflowStatusType.Draft:
      return StatusColors.StatusesGrey;
    case CountryWorkflowStatusType.Published:
      return StatusColors.StatusesGreen;
    case CountryWorkflowStatusType.Retired:
      return StatusColors.StatusesRed;
  }
};

export const getColorForCountryWorkflowTemplateStatusRoom = (statusId: number): StatusColors => {
  switch (statusId) {
    case CountryWorkflowStatusType.Draft:
      return StatusColors.StatusesGrey;
    case CountryWorkflowStatusType.Published:
      return StatusColors.StatusesGreen;
    case CountryWorkflowStatusType.Retired:
      return StatusColors.StatusesRed;
  }
};

export const getGeneralStatusColor = (statusId: number): StatusColors => {
  return statusColorIdToCssClass[statusId];
};

// TPT status color helpers

export const getTPTColorForCountryMilestoneTemplateStatusDomain = (statusId: number): StatusColor => {
  switch (statusId) {
    case CountryMilestoneTemplateStatusDomain.Active:
      return 'green';
    case CountryMilestoneTemplateStatusDomain.Inactive:
      return 'red';
  }
};

export const getTPTColorForCountryMilestoneTemplateStatusRoom = (statusId: number): StatusColor => {
  switch (statusId) {
    case CountryMilestoneTemplateStatusRoom.Planned:
      return 'blue';
    case CountryMilestoneTemplateStatusRoom.Completed:
      return 'green';
    case CountryMilestoneTemplateStatusRoom.NotApplicable:
      return 'red';
  }
};

export const getTPTColorForCountryWorkflowTemplateStatusDomain = (statusId: number): StatusColor => {
  switch (statusId) {
    case CountryWorkflowStatusType.Draft:
      return 'grey';
    case CountryWorkflowStatusType.Published:
      return 'green';
    case CountryWorkflowStatusType.Retired:
      return 'red';
  }
};

export const getTPTColorForCountryWorkflowTemplateStatusRoom = (statusId: number): StatusColor => {
  switch (statusId) {
    case CountryWorkflowStatusType.Draft:
      return 'grey';
    case CountryWorkflowStatusType.Published:
      return 'green';
    case CountryWorkflowStatusType.Retired:
      return 'red';
  }
};

export const getTPTGeneralStatusColor = (statusId: number): StatusColor => {
  return statusColorIdToTPTColor[statusId];
};
